export interface MarketingNavItem {
	key: string;
	basePath: string;
	navLabel: string;
}

export const MARKETING_NAV_ITEMS: MarketingNavItem[] = [
	{ key: "feature", basePath: "/features", navLabel: "Features" },
	{ key: "hardware", basePath: "/hardware", navLabel: "Hardware" },
	{ key: "solution", basePath: "/solutions", navLabel: "Solutions" },
	{ key: "rider", basePath: "/riders", navLabel: "Riders" },
	{ key: "track-owner", basePath: "/track-owners", navLabel: "Track Owners" },
	{ key: "promoter", basePath: "/promoters", navLabel: "Promoters" },
	{ key: "safety", basePath: "/safety", navLabel: "Safety" },
	{ key: "pricing", basePath: "/pricing", navLabel: "Pricing" },
];
